/* EVENTS */
export const GET_PATIENTS = "GET_PATIENTS"
export const GET_PATIENTS_SUCCESS = "GET_PATIENTS_SUCCESS"
export const GET_PATIENTS_FAIL = "GET_PATIENTS_FAIL"

export const GET_PATIENTS_DETAILS = "GET_PATIENTS_DETAILS"
export const GET_PATIENTS_DETAILS_SUCCESS = "GET_PATIENTS_DETAILS_SUCCESS"
export const GET_PATIENTS_DETAILS_FAIL = "GET_PATIENTS_DETAILS_FAIL"

export const ADD_NEW_PATIENTS = "ADD_NEW_PATIENTS"
export const ADD_PATIENTS_SUCCESS = "ADD_PATIENTS_SUCCESS"
export const ADD_PATIENTS_FAIL = "ADD_PATIENTS_FAIL"

export const UPDATE_PATIENTS = "UPDATE_PATIENTS"
export const UPDATE_PATIENTS_SUCCESS = "UPDATE_PATIENTS_SUCCESS"
export const UPDATE_PATIENTS_FAIL = "UPDATE_PATIENTS_FAIL"

export const DELETE_PATIENTS = "DELETE_PATIENTS"
export const DELETE_PATIENTS_SUCCESS = "DELETE_PATIENTS_SUCCESS"
export const DELETE_PATIENTS_FAIL = "DELETE_PATIENTS_FAIL"

export const RESET_PATIENTS_STATE = 'RESET_PATIENTS_STATE';
